(() => {
  'use strict';
  if (typeof window === 'undefined' || customElements.get('lisa-flash-sale')) return;
  const now = () => Date.now();
  class SaleLabel extends HTMLElement {
    connectedCallback() { this.update(); this.timer = setInterval(() => this.update(), 1000); }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      if (!this.product) {
        const data = this.querySelector('[data-lisa-sale-product]');
        try { this.product = JSON.parse(data?.textContent || 'null'); } catch (_) {}
      }
      const time = now();
      let product = this.product;
      if (product && this.dataset.selectedVariant) {
        const variants = product.variants.filter(variant => String(variant.id) === this.dataset.selectedVariant);
        product = { ...product, variants, variantCount: variants.length, available: variants.some(variant => variant.available) };
      }
      const sale = product && window.LisaSales?.offer(product, time);
      this.hidden = !sale;
      const regular = this.parentElement?.querySelector('[data-lisa-regular-price]');
      if (regular) regular.hidden = Boolean(sale);
      if (!sale) return;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
      const money = cents => formatter.format(cents / 100);
      const seconds = Math.max(0, Math.ceil((Date.parse(sale.ends) - time) / 1000));
      this.querySelector('[data-countdown]').textContent = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
      const signature = JSON.stringify(sale);
      if (signature === this.signature) return;
      this.signature = signature;
      this.querySelector('[data-regular]').textContent = money(sale.price);
      const discounted = this.querySelector('[data-discounted]');
      discounted.classList.add('lisa-price-amount');
      discounted.replaceChildren();
      if (sale.from) discounted.append(document.createTextNode(this.dataset.from + ' '));
      const sellingPrice = sale.salePrice;
      formatter.formatToParts(sellingPrice / 100).forEach(part => {
        if (part.type === 'integer' || part.type === 'group') {
          const whole = document.createElement('span');
          whole.className = 'lisa-price-whole';
          whole.textContent = part.value;
          discounted.append(whole);
        } else {
          discounted.append(document.createTextNode(part.value));
        }
      });
      this.querySelector('[data-unit]').textContent = sale.pack ? ' · ' + sale.packText + sale.pluralText : '';
      this.querySelector('[data-pack]').textContent = sale.pack ? money(Math.round(sale.salePrice / sale.quantity)) + ' / ' + sale.unitText : '';
    }
  }
  if (!customElements.get('lisa-flash-sale')) customElements.define('lisa-flash-sale', SaleLabel);
})();
